import React, { useEffect, useState } from "react";
// import { Link } from "react-router-dom";
import SideMenu from "../sidemenu";
import "./index.scss";
import { SidebarSection } from "../../constants/constant";
import SideBarHeader from "../header/LoggedInHeader";
// import axios, { AxiosError } from "axios";
import api from "../../api";
import Pagination from "./pagination";
import { RestaurantDetailInterface, RestaurantInterface } from "./interFace";
import Loader from "../Loader";
import { ToastContainer, toast } from "react-toastify";
// declare var bootstrap: any;

function RestaurantList() {
  const [showNav, setShowNav] = useState(true);
  const [error, setError] = useState<string | null>(null);
  const [restaurantData, setRestaurantData] = useState<RestaurantInterface[]>(
    []
  );
  const [showModal, setShowModal] = useState(false);
  const handleClose = () => setShowModal(false);
  const handleShow = () => setShowModal(true);
  const [restaurantDetailData, setRestaurantDetailData] =
    useState<RestaurantDetailInterface>();
  const [loading, setLoading] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [searchText, setSearchText] = useState("");
  const [restaurantId, setRestaurantId] = useState("");
  const [actionType] = useState<string | null>(null);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const ITEMS_PER_PAGE = 10;

  const handleDeleteClose = () => {
    setShowDeleteModal(false);
    setRestaurantId("");
  };
  const handleDeleteShow = (itemId: string) => {
    setShowDeleteModal(true);
    setRestaurantId(itemId!);
  };

  const restaurantListFetchData = async (page: number, searchText: string) => {
    try {
      setLoading(true);
      const response = await api.get(
        `/api/identity/restaurant/?page=${page}&limit=${ITEMS_PER_PAGE}&searchText=${searchText}`
      );
      const restaurantData = response.data.data.restaurant;
      // console.log(restaurantData);
      const totalCount = response.data.data.totalCount;

      setRestaurantData(restaurantData || []);
      setTotalPages(Math.ceil(totalCount / ITEMS_PER_PAGE));
      setError(
        restaurantData.length > 0
          ? null
          : "No results found for the given search text."
      );
    } catch (error) {
      console.error("Error fetching data:", error);
      setError("An unexpected error occurred. Please try again later.");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    restaurantListFetchData(currentPage, searchText);
  }, [currentPage, searchText]);

  const getRestaurantDetails = (restId: string) => {
    fetchRestaurantDetailData(restId);
  };

  const handleDelete = async () => {
    try {
      if (restaurantId !== null) {
        setLoading(true);
        await api.delete(`/api/identity/restaurant/${restaurantId}`);
        setRestaurantId("");
        handleDeleteClose();
        restaurantListFetchData(currentPage, searchText);
      }
    } catch (error) {
      console.error("Error deleting restaurant:", error);
    } finally {
      setLoading(false);
    }
  };

  const fetchRestaurantDetailData = async (id: string | null) => {
    try {
      if (id !== null) {
        const response = await api.get(`/api/identity/restaurant/${id}`);
        const restaurantDetailData = response.data.data;
        setRestaurantDetailData(restaurantDetailData || null);
        setRestaurantId(id);
        handleShow();
        setError(
          restaurantDetailData ? null : "No results found for the given ID."
        );
      }
    } catch (error) {
      console.error("Error fetching restaurant detail data:", error);
      setError("An unexpected error occurred. Please try again later.");
    }
  };

  const handleApprove = async (restId: string, isApprove: boolean) => {
    try {
      setLoading(true);
      const approvalData = {
        isApproved: isApprove,
      };
      await api
        .put(`/api/identity/restaurant/approve/${restId}`, approvalData)
        .then(function (response) {
          // Perform any additional actions after successful approval if needed
          console.log("Restaurant approved successfully!");
          restaurantListFetchData(currentPage, searchText);
          toast.success(response.data.message);
          handleClose();
          setRestaurantId("");
        })
        .catch(function (error) {
          console.log("Show error notification in update!");
          setLoading(false);
          toast.error("Error in api call!");
          console.log(error);
          return Promise.reject(error);
        });
    } catch (error) {
      console.error("Error approving restaurant:", error);
    } finally {
      setLoading(false);
    }
  };

  const getLocalFormattedDate = (date: string | undefined) => {
    if (date) {
      var localDate = new Date(date);

      const year = localDate.getFullYear();
      const month = String(localDate.getMonth() + 1).padStart(2, '0'); // Adding 1 because getMonth returns 0-based index
      const day = String(localDate.getDate()).padStart(2, '0');
      const formattedDate = `${year}-${month}-${day}`;
      return formattedDate;
    }


    return "";
  }


  return (
    <div>
      {error && <div style={{ color: "red" }}>{error}</div>}
      <div>
        <div className={`body-area${showNav ? " body-pd" : ""}`}>
          <SideBarHeader showNav={showNav} setShowNav={setShowNav} />
          <div className={`l-navbar${showNav ? " showSideNav" : ""}`}>
            <nav className="sideNav">
              <SideMenu />
            </nav>
          </div>
          <div className="pt-4 pb-4">
            <section className="main shadow-sm">
              <div className="row mb-4">
                <div className="col d-flex justify-content-between">
                  <h4>{SidebarSection.RESTAURANT_LIST}</h4>
                  <form className="form-inline my-2 my-lg-0">
                    <input
                      className="form-control mr-sm-2"
                      type="search"
                      placeholder="Search"
                      aria-label="Search"
                      onChange={(e) => setSearchText(e.target.value)}
                    />
                  </form>
                </div>
              </div>
              {loading ? (
                <Loader />
              ) : (
                <div className="row">
                  <div className="table-responsive">
                    <table className="table table-bordered">
                      <thead>
                        <tr className="table-active">
                          <th scope="col">#</th>
                          <th scope="col">NAME</th>
                          <th scope="col">CONTACT NUMBER</th>
                          <th scope="col">EMAIL</th>
                          <th scope="col">BRAND</th>
                          <th scope="col">BRANCH COUNT</th>
                          <th scope="col">STATUS</th>
                          <th scope="col">CREATED AT</th>
                          <th scope="col">LAST UPDATED</th>
                          <th scope="col">APPROVAL STATUS</th>
                          <th scope="col">ACTION</th>
                        </tr>
                      </thead>
                      <tbody>
                        {restaurantData !== null &&
                          (restaurantData as any[]).map((item, index) => (
                            <tr key={index}>
                              <td>{index + 1}</td>
                              <td>{item.name}</td>
                              <td>{item.contactNumber}</td>
                              <td>{item.email}</td>
                              <td>{item.brandDetail.name}</td>
                              <td>{item.branchCount}</td>
                              <td>
                                <span className="badge bg-success rounded-pill">
                                  {item.isActive && "Active"}
                                </span>
                              </td>
                              <td>{getLocalFormattedDate(item.createdAt)}</td>
                              <td>{getLocalFormattedDate(item.updatedAt)}</td>
                              <td>
                                {item?.isApproved ?
                                  <span className="badge bg-success rounded-pill">
                                    APPROVED</span> : <span className="badge bg-error rounded-pill">APPROVAL PENDING</span>}
                                {/* {item.isApproved ? "Approved" : "Approval Pending"} */}
                              </td>

                              <td className="p-1 d-flex">
                                <a
                                  className="btn-action rounded-circle act-btn m-1"
                                  onClick={() => getRestaurantDetails(item._id)}
                                // onClick={() =>
                                //   viewRestaurant(item._id, "view")
                                // }
                                >
                                  <i className="bi bi-eye"></i>
                                </a>
                                {/* <a
                                  className="btn btn-danger rounded-circle act-btn m-1"
                                  onClick={() =>
                                    viewRestaurant(item._id, "edit")
                                  }
                                >
                                  <i className="bi bi-pencil-square"></i>
                                </a> */}
                                <a
                                  className="btn-action rounded-circle act-btn m-1"
                                  onClick={() =>
                                    // viewRestaurant(item._id, "delete")
                                    handleDeleteShow(item._id)
                                  }
                                >
                                  <i className="bi bi-trash"></i>
                                </a>
                              </td>
                            </tr>
                          ))}
                      </tbody>
                    </table>
                  </div>
                  <div><br /></div>

                  <div className=" d-flex  justify-content-end pe-md-5 ">
                    {!loading && (
                      <Pagination
                        currentPage={currentPage}
                        totalPages={totalPages}
                        setCurrentPage={setCurrentPage}
                      />
                    )}
                  </div>
                </div>
              )}
            </section>
          </div>
        </div>
      </div>

      {showDeleteModal && (
        <div
          className="modal"
          tabIndex={-1}
          style={{
            display: "block",
            backgroundColor: "rgba(0, 0, 0, 0.5)",
          }}
        >
          <div className="modal-dialog">
            <div className="modal-content">
              <div className="modal-header">
                <h1 className="modal-title fs-5" id="exampleModalLabel">
                  Delete Restaurant?
                </h1>

                <button
                  type="button"
                  className="btn-close"
                  data-bs-dismiss="modal"
                  aria-label="Close"
                  onClick={handleDeleteClose}
                ></button>
              </div>
              <div className="delete-text">
                {" "}
                Are you sure you want to delete?
              </div>
              <div className="modal-footer">
                <button
                  type="button"
                  className="btn btn-secondary"
                  data-bs-dismiss="modal"
                  onClick={handleDeleteClose}
                >
                  Cancel
                </button>
                <button
                  type="button"
                  onClick={handleDelete}
                  className="btn btn-primary"
                >
                  Delete
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
      {showModal && (
        <div
          className="modal"
          tabIndex={-1}
          style={{ display: "block", backgroundColor: "rgba(0, 0, 0, 0.5)" }}
        >
          <div className="modal-dialog modal-lg ">
            <div className="modal-content ">
              <div className="modal-header">
                <h1 className="modal-title fs-5" id="exampleModalLabel">
                  {actionType === "delete" ? "" : "Restaurant Details"}
                </h1>
                <button
                  type="button"
                  className="btn-close"
                  data-bs-dismiss="modal"
                  aria-label="Close"
                  onClick={handleClose}
                ></button>
              </div>

              <form>
                <div className="modal-body">
                  <table className="table table-bordered view-table">
                    <tbody>
                      <tr>
                        <th>Restaurant</th>
                        <td>{restaurantDetailData?.name}</td>
                        <th>Owner</th>
                        <td>{restaurantDetailData?.owner.name}</td>
                      </tr>
                      <tr>
                        <th>Owner Phone</th>
                        <td>{restaurantDetailData?.owner.contactNumber}</td>
                        <th>Brand Name</th>
                        <td>{restaurantDetailData?.brandDetail.name}</td>
                      </tr>
                      <tr>
                        <th>Owner Email</th>
                        <td>{restaurantDetailData?.owner.email}</td>
                        <th>Tagline</th>
                        <td>{restaurantDetailData?.tagline}</td>
                      </tr>
                      <tr>
                        <th>Contact Person</th>
                        <td>{restaurantDetailData?.contactPerson.name}</td>
                        <th>Currency </th>
                        <td>{restaurantDetailData?.defaultCurrency.name} ({restaurantDetailData?.defaultCurrency.symbol})</td>
                      </tr>
                      <tr>
                        <th>Contact Number</th>
                        <td>
                          {restaurantDetailData?.contactPerson.contactNumber}
                        </td>
                        <th>Place</th>
                        <td>{restaurantDetailData?.place}</td>
                      </tr>
                      <tr>
                        <th>Contact Email</th>
                        <td>{restaurantDetailData?.contactPerson.email}</td>
                        <th>Branch Count</th>
                        <td>{restaurantDetailData?.branchCount}</td>
                      </tr>
                      <tr>
                        <th>Restaurant Phone</th>
                        <td>{restaurantDetailData?.contactNumber}</td>
                        <th>Logo</th>
                        <td>--</td>
                      </tr>
                      <tr>
                        <th>Created At</th>
                        <td>{getLocalFormattedDate(restaurantDetailData?.createdAt)}</td>
                        <th>Last Updated</th>
                        <td>{getLocalFormattedDate(restaurantDetailData?.updatedAt)}</td>
                      </tr>
                      <tr>
                        <th>Approval Status</th>
                        <td>
                          {restaurantDetailData?.isApproved ?
                            <span className="badge bg-success rounded-pill">
                              APPROVED</span> : <span className="badge bg-error rounded-pill">APPROVAL PENDING</span>}
                          {/* {restaurantDetailData?.isApproved
                            ? "Approved"
                            : "Approval Pending"} */}
                        </td>

                        <th>Tax registration document</th>
                        <td>--</td>
                      </tr>
                      <tr>
                        <th>Trade License</th>
                        <td>--</td>
                        <th>Identity Document</th>
                        <td>--</td>
                      </tr>
                      <tr>


                      </tr>
                    </tbody>
                  </table>
                </div>
                <div className="modal-footer">
                  <button
                    type="button"
                    className="btn btn-danger"
                    data-bs-dismiss="modal"
                    onClick={() => handleApprove(restaurantId, false)}
                  >
                    Reject
                  </button>
                  <button
                    type="button"
                    className="btn btn-success"
                    onClick={() => handleApprove(restaurantId, true)}
                  >
                    Approve
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      )}
      <ToastContainer />
    </div>
  );
}

export default RestaurantList;
